import { cn } from "@/lib/utils";

/**
 * Bootstrap/Funding-style binary or n-ary segmented toggle.
 * - track: #F1F1EE
 * - active: solid black + white text
 * - inactive: gray-500
 */
export default function PillToggle({
  value,
  onChange,
  options,
  size = "md",
  testId,
  className,
}) {
  const sizeClass =
    size === "sm"
      ? "h-7 text-[11px]"
      : size === "lg"
        ? "h-11 text-[14px]"
        : "h-9 text-[12px]";

  return (
    <div
      data-testid={testId}
      className={cn(
        "pill-track inline-flex items-center rounded-full p-1",
        sizeClass,
        className,
      )}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            data-testid={`${testId}-${opt.value}`}
            onClick={() => onChange?.(opt.value)}
            className={cn(
              "rounded-full px-3.5 font-semibold transition-all",
              "h-full",
              active
                ? "bg-black text-white shadow-[0_2px_8px_-2px_rgba(0,0,0,0.4)]"
                : "text-zinc-500 hover:text-zinc-700",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
